import { FC } from 'react'

import { PrimaryAlert } from 'src/Components/PrimaryAlert'

export const LowReachCuratorsErrorExperiment: FC = () => (
  <PrimaryAlert
    type='warning'
    hasCross={false}
    title='With your current setup, the reach might be a bit lower than usual.'
  >
    <div>
      Totally fine to continue, but you could explore other genres with more
      curators to boost your chances.
    </div>
  </PrimaryAlert>
)
